import { render, staticRenderFns } from "./HomeLateralTabs.vue?vue&type=template&id=072c8516&scoped=true&"
import script from "./HomeLateralTabs.vue?vue&type=script&lang=js&"
export * from "./HomeLateralTabs.vue?vue&type=script&lang=js&"
import style0 from "./HomeLateralTabs.vue?vue&type=style&index=0&id=072c8516&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c8516",
  null
  
)

export default component.exports